import { Button } from './ui/button';

interface PaginatorProps {
    totalItems: number;
    currentPage: number;
    perPage: number;
    onPageChange: (page: number) => void;
    className?: string;
}

export function Paginator({
    totalItems, 
    currentPage,
    perPage,
    onPageChange,
    className = ''
}: PaginatorProps) {
    // if (totalItems <= perPage) {
    //     return null;
    // }
    const startIndex = (currentPage - 1) * perPage;
    const endIndex = startIndex + perPage;
    const totalPages = Math.ceil(totalItems / perPage);
    return (
        <div className={`grid grid-cols-1 md:grid-cols-3 items-center gap-4 ${className}`}>
          
            <div className="flex items-center justify-center md:justify-start order-2 sm:order-1">
                <div className="text-sm text-muted-foreground">
                    Showing {totalItems > 0 ? startIndex + 1 : 0} to {Math.min(endIndex, totalItems)} of {totalItems} entries
                </div>
            </div>

      
            <div className="flex items-center justify-center space-x-1 order-1 md:order-2">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(1)}
                    disabled={currentPage === 1}
                >
                    First
                </Button>
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </Button>
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    let pageNum;
                    if (totalPages <= 5) {
                        pageNum = i + 1;
                    } else if (currentPage <= 3) {
                        pageNum = i + 1;
                    } else if (currentPage >= totalPages - 2) {
                        pageNum = totalPages - 4 + i;
                    } else {
                        pageNum = currentPage - 2 + i;
                    }

                    return (
                        <Button
                            key={pageNum}
                            variant={currentPage === pageNum ? "default" : "outline"}
                            size="sm"
                            onClick={() => onPageChange(pageNum)}
                            className="w-8 h-8 p-0"
                        >
                            {pageNum}
                        </Button>
                    );
                })}

                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </Button>
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(totalPages)}
                    disabled={currentPage === totalPages}
                >
                    Last
                </Button>
            </div>

          
            <div className="hidden md:flex items-center justify-end order-3">
            
            </div>
        </div>
    );
}
